import { completeTask, startTask } from '@/entities/task';
export async function startTaskAction(taskId, version) {
    await startTask(taskId, version);
}
export async function completeTaskAction(taskId, version, comment) {
    await completeTask(taskId, version, comment);
}
